module.exports = __webpack_public_path__ + "img/seta-anim.aa7051d2.gif";